import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M2.388 13.447l6.896 5.334a1.06 1.06 0 0 0 1.42-.116l11.035-12a.978.978 0 0 0-.086-1.413 1.06 1.06 0 0 0-1.46.083L9.81 16.626l-6.13-4.74a1.059 1.059 0 0 0-1.454.156.979.979 0 0 0 .162 1.405z"
});

var SvgCheckmark = function SvgCheckmark(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgCheckmark;